import {
  Box,
  Grid,
  Typography,
  TextField,
  Dialog,
  DialogContent,
  useTheme,
  useMediaQuery,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import styles from "../InternalTracker.module.css";
import {
  calculateFieldCompletion,
  customTextColor,
} from "../../../utils/const";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { CiMobile3, CiTextAlignCenter } from "react-icons/ci";
import { PiBuildingOfficeLight } from "react-icons/pi";
import { PiUserLight } from "react-icons/pi";
import { IoIosArrowRoundBack } from "react-icons/io";
import { IoIosArrowRoundForward } from "react-icons/io";
import { PiMailboxLight } from "react-icons/pi";
import { useDispatch, useSelector } from "react-redux";
import { getTrackerDetails } from "../../../redux/internal-tracking/InternalTrackerSlice";
import { useFormik } from "formik";
import * as Yup from "yup";
import { addOfficialReferenceValue } from "../../../redux/internalCandidateStaticValue/internalCandidateStaticValue";

const fieldStyle = {
  width: "100%",
  "& .MuiInputBase-root": {
    paddingLeft: "30px", // Adjust padding to make space for the icon
  },
  "& .MuiInputLabel-root": {
    left: "35px",
    fontSize: "14px ", // Adjust label position to align with input text
  },
  "& .MuiInputBase-input": {
    paddingBottom: "7px", // Add padding to the input text itself to make space for the icon
  },
  "& .MuiInputLabel-shrink": {
    left: "35px",
    fontSize: "14px ", // Adjust label position when it shrinks
  },
  padding: "7px",
};

const InternalTrackerSubmit = ({ setMenuName, setMenuId }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [openCompleteProfile, setOpenCompleteProfile] = useState(false);
  const [isPrivate, setIsPrivate] = useState("");
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();
  const dispatch = useDispatch();
  const { formik1 } = location?.state || {};
  const { formik2 } = location?.state || {};
  const { row } = location?.state || {};
  const trackerStatus = useSelector((state) => state.tracker.status);
  const locations = useSelector((state) => state.location);
  const profile = useSelector((state) => state.profile.data);
  const internalStatus = useSelector((state) => state.tracker.status);
  const officialReferenceData = useSelector(
    (state) => state.internalCandidateStaticValue.officialReferenceData
  );

  const personalDetails = useSelector(
    (state) => state.internalCandidateStaticValue.data
  );

  const [data, setData] = useState(
    location.state ||
      JSON.parse(localStorage.getItem("internalTrackerCandidateAddOrUpdate"))
  );

  useEffect(() => {
    if (location.state) {
      localStorage.setItem(
        "internalTrackerCandidateAddOrUpdate",
        JSON.stringify(location.state)
      );
      setData(location.state);
    }
  }, [location.state]);

  const formik = useFormik({
    initialValues: {
      employer_company_name:
        data?.row?.employer_company_name ||
        officialReferenceData?.employer_company_name ||
        null,
      employer_manager_name:
        data?.row?.employer_manager_name ||
        officialReferenceData?.employer_manager_name ||
        null,
      employer_mobile_no:
        data?.row?.employer_mobile_no ||
        officialReferenceData?.employer_mobile_no ||
        null,
      employer_email:
        data?.row?.employer_email ||
        officialReferenceData?.employer_email ||
        null,
      referrer_company_name:
        data?.row?.referrer_company_name ||
        officialReferenceData?.referrer_company_name ||
        null,
      referrer_manager_name:
        data?.row?.referrer_manager_name ||
        officialReferenceData?.referrer_manager_name ||
        null,
      referrer_mobile_no:
        data?.row?.referrer_mobile_no ||
        officialReferenceData?.referrer_mobile_no ||
        null,
      referrer_email:
        data?.row?.referrer_email ||
        officialReferenceData?.referrer_email ||
        null,
      isPrivate: isPrivate,
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {},
  });

  const handleClose = () => {
    setOpen(false);
  };
  const handleClickCompleteProfileOpen = () => {
    if (
      formik1?.prefer_tax_team === "contract" ||
      formik1?.prefer_tax_team === "contract_to_hire"
    ) {
      if (
        formik?.values?.employer_company_name !== null &&
        formik?.values?.employer_company_name !== "" &&
        formik?.values?.employer_manager_name !== null &&
        formik?.values?.employer_manager_name !== "" &&
        formik?.values?.employer_mobile_no !== null &&
        formik?.values?.employer_mobile_no !== "" &&
        formik?.values?.employer_email !== null &&
        formik?.values?.employer_email !== "" &&
        formik?.values?.referrer_company_name !== null &&
        formik?.values?.referrer_company_name !== "" &&
        formik?.values?.referrer_manager_name !== null &&
        formik?.values?.referrer_manager_name !== "" &&
        formik?.values?.referrer_mobile_no !== null &&
        formik?.values?.referrer_mobile_no !== "" &&
        formik?.values?.referrer_email !== null &&
        formik?.values?.referrer_email !== ""
      ) {
        // setOpen(true);
        handleOnSubmitTracker();
      } else {
        setOpenCompleteProfile(true);
      }
    } else {
      if (
        formik?.values?.referrer_company_name !== null &&
        formik?.values?.referrer_company_name !== "" &&
        formik?.values?.referrer_manager_name !== null &&
        formik?.values?.referrer_manager_name !== "" &&
        formik?.values?.referrer_mobile_no !== null &&
        formik?.values?.referrer_mobile_no !== "" &&
        formik?.values?.referrer_email !== null &&
        formik?.values?.referrer_email !== ""
      ) {
        handleOnSubmitTracker();
      } else {
        setOpenCompleteProfile(true);
      }
    }
  };

  const handleCompleteProfileClose = () => {
    setOpenCompleteProfile(false);
  };

  const handleCloseCompleteProfile = () => {
    dispatch(addOfficialReferenceValue(formik.values));
    setMenuName("Profile Review");
    setMenuId(3);
  };

  const handleMobileNoChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 10) {
      formik.setFieldValue("employer_mobile_no", value);
    }
  };

  const handleMobileOfficialNoChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 10) {
      formik.setFieldValue("referrer_mobile_no", value);
    }
  };

  let userData = {
    email: formik1?.email,
    mobile_no: formik1?.mobile_no,
    full_name: formik1?.full_name,
    // gender: formik1?.gender,
    current_job_title: formik1?.current_job_title,
    total_experience: formik1?.total_experience,
    current_location: formik1?.current_location,
    // prefer_location: [1, 2],
    prefer_location: formik1?.prefer_location,
    work_preference: formik1?.work_preference,
    alternative_mobile_no: formik1?.alternative_mobile_no,
    work_authorization: formik1?.work_authorization,
    prefer_tax_team: "full_Time",
    p_tax_team: formik1?.prefer_tax_team,
    rate: formik1?.rate,
    linkedin_profile_url: formik1?.linkedin_profile_url,
    resume: formik1?.resume,
    current_company: formik2?.current_company,
    domain_name: formik2?.domain_name,
    highest_qualification: formik2?.highest_qualification,
    university: formik2?.university,
    // passing_year: formik2?.passing_year,
    // time_zone: formik2?.time_zone,
    skills: formik2?.skills,
    secondary_skills: formik2?.secondary_skills,
    employer_company_name: formik?.values?.employer_company_name,
    employer_manager_name: formik?.values?.employer_manager_name,
    employer_mobile_no: formik?.values?.employer_mobile_no,
    employer_email: formik?.values?.employer_email,
    referrer_company_name: formik?.values?.referrer_company_name,
    referrer_manager_name: formik?.values?.referrer_manager_name,
    referrer_mobile_no: formik?.values?.referrer_mobile_no,
    referrer_email: formik?.values?.referrer_email,
    private: isPrivate == "private" ? true : false,
    // empty_percentage: completionData?.emptyPercentage,
    // filled_percentage: completionData?.filledPercentage,
  };

  const completionData = calculateFieldCompletion(
    userData,
    formik1?.prefer_tax_team
  );

  const handleOnSubmitTracker = () => {
    dispatch(addOfficialReferenceValue(formik.values));
    setMenuName("Profile Review");
    setMenuId(3);
  };

  useEffect(() => {
    if (
      trackerStatus === "create_candidate_intenal_succeeded" ||
      trackerStatus === "update_candidate_intenal_succeeded"
    ) {
      let queryString = `page=1&page_size=10`;
      handleClose();
      dispatch(getTrackerDetails(queryString));
      navigate("/internal-tracker");
    }
  }, [trackerStatus]);

  useEffect(() => {
    if (data !== undefined) {
      if (data?.row?.internal) {
        setIsPrivate("internal");
      } else if (data?.row?.private) {
        setIsPrivate("private");
      }
    }
  }, [data]);

  const getLocationById = (id) => {
    let locationResult = locations?.data?.locations?.find(
      (res) => res.id === id
    );
    return locationResult?.name;
  };

  useEffect(() => {
    formik.setFieldValue("isPrivate", isPrivate);
  }, [isPrivate]);

  return (
    <>
      <Box
        className={styles.candidate_structure}
        sx={{ margin: "0 14px 20px" }}
      >
        {personalDetails?.prefer_tax_team?.includes("full_Time") ? (
          ""
        ) : (
          <Box className={styles.employer_details} sx={{ margin: "0 0 14px" }}>
            <Typography sx={{ color: customTextColor }}>
              Employer Details
            </Typography>

            <Grid container>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiUserLight style={{ fontSize: "25px", color: "#3f475a" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Employer’s Name"
                  variant="standard"
                  type="text"
                  name="employer_manager_name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.employer_manager_name ?? null}
                  sx={fieldStyle}
                />
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiMailboxLight
                    style={{ fontSize: "25px", color: "#3f475a" }}
                  />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Official E-Mail ID "
                  variant="standard"
                  type="text"
                  name="employer_email"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.employer_email ?? null}
                  sx={fieldStyle}
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <CiMobile3 style={{ fontSize: "25px", color: "#3f475a" }} />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Phone No"
                  variant="standard"
                  type="text"
                  name="employer_mobile_no"
                  onChange={handleMobileNoChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.employer_mobile_no ?? null}
                  sx={fieldStyle}
                />
              </Grid>

              <Grid
                item
                xs={12}
                sm={12}
                md={6}
                lg={6}
                sx={{ padding: "5px 10px 0 10px", position: "relative" }}
              >
                <Box className={styles.icon_style}>
                  <PiBuildingOfficeLight
                    style={{ fontSize: "25px", color: "#3f475a" }}
                  />
                </Box>
                <TextField
                  id="standard-basic"
                  label="Company Name"
                  variant="standard"
                  name="employer_company_name"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.employer_company_name ?? null}
                  sx={fieldStyle}
                />
              </Grid>
            </Grid>
          </Box>
        )}

        <Box className={styles.employer_details}>
          <Typography sx={{ color: customTextColor }}>
            Official Refference (Optional)
          </Typography>

          <Grid container>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "5px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiUserLight style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Manager’s Name"
                variant="standard"
                type="text"
                name="referrer_manager_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_manager_name ?? null}
                sx={fieldStyle}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "5px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiMailboxLight
                  style={{ fontSize: "25px", color: "#3f475a" }}
                />
              </Box>
              <TextField
                id="standard-basic"
                label="Official E-Mail ID "
                variant="standard"
                type="text"
                name="referrer_email"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_email ?? null}
                sx={fieldStyle}
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "5px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <CiMobile3 style={{ fontSize: "25px", color: "#3f475a" }} />
              </Box>
              <TextField
                id="standard-basic"
                label="Phone No"
                variant="standard"
                type="text"
                name="referrer_mobile_no"
                onChange={handleMobileOfficialNoChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_mobile_no ?? null}
                sx={fieldStyle}
              />
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              md={6}
              lg={6}
              sx={{ padding: "5px 10px 0 10px", position: "relative" }}
            >
              <Box className={styles.icon_style}>
                <PiBuildingOfficeLight
                  style={{ fontSize: "25px", color: "#3f475a" }}
                />
              </Box>
              <TextField
                id="standard-basic"
                label="Company Name"
                variant="standard"
                name="referrer_company_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.referrer_company_name ?? null}
                sx={fieldStyle}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box className={styles.add_candidate_btns}>
        <Box className={styles.add_back_btns}>
          <button
            // onClick={() =>
            //   navigate("/internal-tracker-candidate", {
            //     state: {
            //       prevData: formik1,
            //       prevData1: formik2,
            //       selectedFileName: selectedFileName,
            //       officialReferenceData: formik?.values,
            //       row: row,
            //     },
            //   })
            // }
            // style={{
            //   border: "1.5px solid #4285f4",
            //   marginRight: "10px",
            //   padding: "4.5px 10px ",
            // }}
            onClick={() => {
              setMenuName("Skill and Experience");
              setMenuId(1);
            }}
            style={{
              border: "1.5px solid #4285f4",
              marginRight: "10px",
              padding: "4.5px 10px ",
            }}
          >
            <IoIosArrowRoundBack
              style={{ fontSize: "25px", color: "#4285f4" }}
            />
          </button>
        </Box>
        <button
          onClick={handleClickCompleteProfileOpen}
          style={{
            backgroundColor: "#3856a6 ",
            padding: "5.5px 5px 5.5px 10px ",
          }}
        >
          {data?.row !== undefined ? "Skip & Update" : "Skip & Submit"}
          <IoIosArrowRoundForward
            style={{ fontSize: "25px", marginLeft: "5px" }}
          />
        </button>
      </Box>
      <Dialog
        fullScreen={fullScreen}
        open={openCompleteProfile}
        onClose={handleCompleteProfileClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth="md"
        fullWidth={true}
      >
        <DialogContent sx={{ padding: "0 20px" }}>
          <Box className={styles.recruiter_matches}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <b style={{ fontSize: "80px ", marginRight: "20px" }}> 1</b>

              <Box>
                <Typography>
                  Filed can impact on your filter during the filtration{" "}
                  <Typography>So fill all filed carefully.</Typography>
                </Typography>
                <Typography>Nothing to worry complete it latter.</Typography>
              </Box>
            </Box>
            {/* <img src={profile} alt="" /> */}
          </Box>

          <Box className={styles.complete_btn}>
            <Box className={styles.complete_add_btns}>
              <button
                style={{
                  marginRight: "10px",
                  backgroundColor: "#4285f4 ",
                  padding: "7.5px 10px ",
                  marginRight: "10px",
                }}
                onClick={handleCompleteProfileClose}
              >
                Complete
              </button>
            </Box>
            <button
              style={{ backgroundColor: "#3856a6 ", padding: "7.5px 10px " }}
              onClick={handleCloseCompleteProfile}
            >
              Do it Later
            </button>
          </Box>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth="md"
        fullWidth={true}
      >
        <Box sx={{ margin: "18px 15px", padding: "0 15px 0 15px" }}>
          <Typography>
            <b>Hi, {profile?.profile?.full_name}</b>
          </Typography>
          <Typography>
            You have successfully completed {completionData?.filledPercentage}
            {"%"} profile tracking for better in search result
          </Typography>
          {completionData?.emptyPercentage > 0 && (
            <Typography>
              please complete remain {completionData?.emptyPercentage}
              {"%"}
              .   
              <b
                style={{
                  color: "#3856a6",
                  textDecoration: "underline",
                  cursor: "pointer",
                }}
              >
                Complete now
              </b>
            </Typography>
          )}
        </Box>

        <DialogContent sx={{ padding: "0 20px" }}>
          <Box className={styles.recruiter_matches_section}>
            <Box style={{ color: customTextColor }}>
              <Typography>
                <b>{personalDetails?.full_name}</b>
              </Typography>
              <Typography>
                {personalDetails?.current_job_title},{" "}
                {personalDetails?.total_experience} Years of Experience
              </Typography>
              <Typography>
                {getLocationById(personalDetails?.current_location)}
              </Typography>
            </Box>
            <span>
              <Typography
                sx={{
                  fontSize: "50px !important",
                  color: "#00a349",
                  position: "relative",
                  top: "10px",
                }}
              >
                <b>
                  {completionData?.filledPercentage}
                  {"%"}
                </b>
              </Typography>

              <b>Profile Completed</b>
            </span>
            {/* <img src={image} alt="" /> */}
          </Box>
          <hr></hr>
          <Box className={styles.consultant_listing_text}>
            <Box>
              <Typography sx={{ marginLeft: "10px" }}>
                <b>Who can view this consult profile?</b>
              </Typography>
              <Typography>
                <input
                  type="radio"
                  id="private"
                  name="private"
                  checked={isPrivate === "private"}
                  onChange={() => setIsPrivate("private")}
                />
                <label htmlFor="private" style={{ marginLeft: "10px" }}>
                  Private (only you can view)
                </label>
                <br />
              </Typography>
              <Typography>
                <input
                  type="radio"
                  id="internal"
                  name="private"
                  checked={isPrivate === "internal"}
                  onChange={() => setIsPrivate("internal")}
                />
                <label htmlFor="internal" style={{ marginLeft: "10px" }}>
                  Internal Employees Access <b>(recommended)</b>
                </label>
              </Typography>
              {isPrivate === "private" && (
                <Typography sx={{ marginTop: "10px" }}>
                  <b>Note</b> : You might be losing some other colleagues
                  profiles until this profile is not converted into internal
                  employee access.
                </Typography>
              )}
            </Box>
            <button
              style={
                internalStatus === "loading"
                  ? {
                      padding: "4px 25px",
                      backgroundColor: "#3856a6 ",
                      alignSelf: "flex-end",
                    }
                  : {
                      backgroundColor: "#3856a6 ",
                      padding: "7.5px 12px ",
                      alignSelf: "flex-end",
                    }
              }
              onClick={handleOnSubmitTracker}
              disabled={!isPrivate}
            >
              {internalStatus === "loading" ? (
                <CircularProgress size={20} sx={{ color: "#fff" }} />
              ) : (
                "Confirm"
              )}
            </button>
          </Box>
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
    // </RootComponents>
  );
};

export default InternalTrackerSubmit;
